/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-08-24 10:08:27
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import _ from "lodash";
import { api, sendAsync } from "../.././app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../app/store";
import { fromMaterialJson, Material } from "../../models/material";
import { Page, pageOf } from "../../models/page";
import { Pager } from "../../models/pagination";
import {
  commodityDetail,
  commoditylogoutOrEnable,
  commodityLogoutOrEnableList,
  commodityPage,
  commodityPageParams,
  commoditySave,
  commoditySubmitBody,
  getGoodsNo,
  getLinKangdurgstore,
  getServiceNo,
  linkangParams,
  logoutOrEnableBody,
  saveLinkangDurg,
} from "../../services/commodity";

const initialState = {
  CommodityData: [],
  Total: 0,
  Current: 1,
  selectId: 0,
  CommodityDetail: {},
  YPData: [],
  ZBData: [],
  JXData: [],
  PCData: [],
  YFData: [],
  ShopNo: 0,
  saveCurrent: 1,
  saveTotal: 0,
  saveData: [],
};

//导入药品
export const LinKangDurgAsync = createAsyncThunk<
  void,
  linkangParams,
  RootThunkApi<void>
>("/commodity/LinKangDurgSave", async (params, api) => {
  return sendAsync(getLinKangdurgstore(params), api);
});

//导入标准药品
export const saveLinKangDurgAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("/commodity/saveDurg", async (Ids, api) => {
  return sendAsync(saveLinkangDurg(Ids), api);
});

export const commodityLogoutOrEnableListAsync = createAsyncThunk<
  void,
  logoutOrEnableBody,
  RootThunkApi<void>
>("commodity/logouorEnableList", async (body, api) => {
  return sendAsync(commodityLogoutOrEnableList(body), api);
});

export const commoditySlice = createSlice({
  name: "commodity",
  initialState,
  reducers: {
    setData(state, action) {
      state.CommodityData = action.payload;
    },
    setTotal(state, action) {
      state.Total = action.payload;
    },
    setCurrent(state, action) {
      state.Current = action.payload;
    },
    setCommodityDetail(state, action) {
      state.CommodityDetail = action.payload;
    },
    setSelectId(state, action) {
      state.selectId = action.payload;
    },
    setShopNo(state, action) {
      state.ShopNo = action.payload;
    },
    setSaveCurrent(state, action) {
      state.saveCurrent = action.payload;
    },
    setSaveTotal(state, action) {
      state.saveTotal = action.payload;
    },
    setSaveData(state, action) {
      state.saveData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LinKangDurgAsync.fulfilled, (state, action: any) => {
      state.saveData = action.payload.records;
      state.saveTotal = action.payload.total;
    });
    builder.addCase(saveLinKangDurgAsync.fulfilled, (state, action: any) => {
      notification.success({
        message: action.payload,
        duration: 3,
      });
    });
  },
});

export const {
  setData,
  setTotal,
  setCurrent,
  setCommodityDetail,
  setSelectId,
  setShopNo,
  setSaveCurrent,
  setSaveData,
  setSaveTotal,
} = commoditySlice.actions;

//分页
export function pageCommodity(params: commodityPageParams): RootThunk {
  return api(commodityPage(params), (data: any, dispatch) => {
    const records = data.records;
    const total = data.total;
    dispatch(setTotal(total));
    dispatch(setData(records));
  });
}

export const pageCommodityAsync = createAsyncThunk<
  Page<Material>,
  commodityPageParams,
  RootThunkApi
>("Commodity/page", async (params, api) => {
  return sendAsync(commodityPage(params), api).then((data) =>
    pageOf(
      data,
      _.chain(data.records)
        .map((m) => fromMaterialJson(m))
        .value()
    )
  );
});

//启用注销
export const logoutOrenableCommodity = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>("commodity/start", async (id, api) => {
  return sendAsync(commoditylogoutOrEnable(id), api);
});

//新增
export const saveCommodityAsync = createAsyncThunk<
  void,
  commoditySubmitBody,
  RootThunkApi<void>
>("commodity/save", async (body, api) => {
  return sendAsync(commoditySave(body), api);
});

//详情
export function getCommodityDetail(id: number): RootThunk {
  return api(commodityDetail(id), (data: any, dispatch) => {
    dispatch(setCommodityDetail(data));
  });
}

//麟康药品
export const getLinKangDurgAsync = createAsyncThunk<
  Page<Material>,
  linkangParams,
  RootThunkApi
>("commodity/LinKangDurgStora", async (params, api) => {
  return sendAsync(getLinKangdurgstore(params), api).then((data) =>
    pageOf(
      data,
      _.chain(data.records)
        .map((m) => fromMaterialJson(m))
        .value()
    )
  );
});

//药品商品编码
export function getShopGoodsNo(): RootThunk {
  return api(getGoodsNo(), (data: any, dispatch) => {
    dispatch(setShopNo(data));
  });
}

//诊疗商品编码
export function getServerGoodsNo(): RootThunk {
  return api(getServiceNo(), (data: any, dispatch) => {
    dispatch(setShopNo(data));
  });
}

export const selectCommodityData = (state: RootState) =>
  state.commodity.CommodityData;

export const selectorTotal = (state: RootState) => state.commodity.Total;

export const selectCurrent = (state: RootState) => state.commodity.Current;

export const selectCommodityDetail = (state: RootState) =>
  state.commodity.CommodityDetail;

export const selectShopNo = (state: RootState) => state.commodity.ShopNo;

export const selectCommodityId = (state: RootState) => state.commodity.selectId;

export const selectSaveData = (state: RootState) => state.commodity.saveData;

export const selectSaveCurrent = (state: RootState) =>
  state.commodity.saveCurrent;

export const selectSaveTotal = (state: RootState) => state.commodity.saveTotal;

export default commoditySlice.reducer;
